import React, { useState } from 'react';

// Main Gear component
const Gear = () => {
  // State to keep track of the currently selected gear
  const [selectedGear, setSelectedGear] = useState('P'); // Default to Park

  // Define the available gear positions
  const gears = ['P', 'R', 'N', 'D', 'M']; // P: Park, R: Reverse, N: Neutral, D: Drive, M: Manual/Sport

  // Function to handle gear selection
  const handleGearSelect = (gear) => {
    setSelectedGear(gear);
    console.log(`Gear selected: ${gear}`); // Log the selected gear for demonstration
    // In a real application, you might trigger an action based on gear selection here
  };

  return (
    <div style={{
      minHeight: '100vh',
      backgroundColor: '#1a202c', // bg-gray-900
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '1rem', // p-4
      fontFamily: 'Inter, sans-serif'
    }}>
      <div style={{
        backgroundColor: '#2d3748', // bg-gray-800
        padding: '2rem', // p-8
        borderRadius: '1.5rem', // rounded-3xl
        boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)', // Simplified shadow-2xl
        border: '1px solid #4a5568', // border border-gray-700
        maxWidth: '24rem', // max-w-sm
        width: '100%' // w-full
      }}>
        <h1 style={{
          fontSize: '1.875rem', // text-3xl
          fontWeight: '700', // font-bold
          color: '#fff', // text-white
          marginBottom: '1.5rem', // mb-6
          textAlign: 'center' // text-center
        }}>
          New Generation Gear Selector
        </h1>

        <div style={{
          display: 'flex',
          flexDirection: 'column',
          gap: '1rem' // space-y-4
        }}>
          {gears.map((gear) => (
            <button
              key={gear}
              onClick={() => handleGearSelect(gear)}
              style={{
                position: 'relative', // relative
                width: '100%', // w-full
                paddingTop: '1rem', // py-4
                paddingBottom: '1rem', // py-4
                paddingLeft: '1.5rem', // px-6
                paddingRight: '1.5rem', // px-6
                borderRadius: '1rem', // rounded-2xl
                fontSize: '1.25rem', // text-xl
                fontWeight: '600', // font-semibold
                transition: 'all 0.3s ease-in-out', // transition-all duration-300 ease-in-out
                outline: 'none', // focus:outline-none
                // Note: Focus rings and hover effects are not directly replicable with pure inline CSS
                // Conditional styles based on selectedGear
                backgroundColor: selectedGear === gear ? '#2563eb' : '#4a5568', // bg-gradient-to-r (simplified) or bg-gray-700
                color: selectedGear === gear ? '#fff' : '#cbd5e0', // text-white or text-gray-300
                boxShadow: selectedGear === gear ? '0 4px 6px rgba(0, 0, 0, 0.1)' : 'none', // shadow-lg (simplified)
                transform: selectedGear === gear ? 'scale(1.05)' : 'scale(1)' // transform scale-105
              }}
            >
              {gear}
              {selectedGear === gear && (
                <span style={{
                  position: 'absolute', // absolute
                  top: '0.5rem', // top-2
                  right: '0.5rem', // right-2
                  color: '#bfdbfe', // text-blue-200
                  fontSize: '0.875rem' // text-sm
                }}>
                  Selected
                </span>
              )}
            </button>
          ))}
        </div>

        <div style={{
          marginTop: '2rem', // mt-8
          textAlign: 'center', // text-center
          color: '#a0aec0' // text-gray-400
        }}>
          <p style={{ fontSize: '1.125rem' }}> {/* text-lg */}
            Current Gear: <span style={{
              fontWeight: '700', // font-bold
              color: '#63b3ed' // text-blue-400
            }}>{selectedGear}</span>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Gear;
